<template>
  <section>
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="modal-card-title">Public Link to Listing</div>
      </header>
      <section class="modal-card-body">

        <div class="is-size-7">Here is the public link to your listing...</div>

        <div class="is-divider" />

        <b-input
          rows="2"
          v-model="$store.state.listing.attributes.publicLink"
          readonly
          type="textarea"
          @focus="$event.target.select()"
        ></b-input>

      </section>

      <footer class="modal-card-foot">
        <button
          class="button"
          v-bind:disabled="$store.state.isUploading"
          type="button"
          @click="() => { $parent.close() }"
        >Close</button>
      </footer>

    </div>
  </section>
</template>

<script>
export default {
  components: {},

  data() {
    return {};
  },

  methods: {}
};
</script>

<style>
</style>
